export default __webpack_public_path__ + "static/somerville-752bd89651e77b92a2df5663553495ef.jpg";